export enum StreamState {
  Live = "LIVE",
  Offline = "OFFLINE",
  Unknown = "UNKNOWN",
  AuthError = "AUTH_ERROR",
}
